// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-pdf[data-v-642ce154]{width:100%;border-collapse:collapse;table-layout:fixed;text-align:center;font-size:12px}.table-pdf td[data-v-642ce154],.table-pdf th[data-v-642ce154]{border:1px solid #e6e6e6;padding:10px 5px}", ""]);
// Exports
module.exports = exports;
